import { Printer, FileText, RefreshCw } from "lucide-react";
import { formatCurrency } from "../../lib/utils";

const methodLabel = { NU: "Numerário", CC: "Multicaixa", TB: "Transferência", OU: "Outro" };

export const POSInvoicesView = ({ invoices, loading, onPrint, onRefresh }) => {
  const total = invoices.reduce((s, i) => s + (i.total || 0), 0);
  return (
    <div className="flex-1 min-h-0 flex flex-col" data-testid="pos-invoices-view">
      <div className="flex items-center gap-3 px-3 py-2 border-b border-white/5">
        <h2 className="text-sm font-semibold text-zinc-200">Faturas emitidas hoje</h2>
        <span className="text-[11px] text-zinc-500">{invoices.length} documentos</span>
        <span className="ml-auto text-xs text-zinc-400">
          Total: <strong className="font-mono text-emerald-400" data-testid="pos-invoices-total">{formatCurrency(total)}</strong>
        </span>
        <button onClick={onRefresh} className="w-8 h-8 rounded-md flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/5" data-testid="pos-invoices-refresh">
          <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-3">
        <table className="w-full text-xs">
          <thead>
            <tr className="text-left text-zinc-400 border-b border-white/10">
              <th className="py-2 font-medium">Documento</th>
              <th className="py-2 font-medium">Hora</th>
              <th className="py-2 font-medium">Cliente</th>
              <th className="py-2 font-medium">Pagamento</th>
              <th className="py-2 font-medium text-right">Total</th>
              <th className="py-2 w-24" />
            </tr>
          </thead>
          <tbody>
            {invoices.map((inv) => (
              <tr key={inv.invoice_id} className="border-b border-white/5 hover:bg-white/[0.03]" data-testid={`pos-invoice-row-${inv.invoice_id}`}>
                <td className="py-2 font-mono font-semibold text-zinc-100">{inv.invoice_number}</td>
                <td className="py-2 text-zinc-400">{inv.created_at ? new Date(inv.created_at).toLocaleTimeString("pt-AO", { hour: "2-digit", minute: "2-digit" }) : ""}</td>
                <td className="py-2 text-zinc-300 truncate max-w-[200px]">{inv.customer_name || "Consumidor Final"}</td>
                <td className="py-2 text-zinc-400">{methodLabel[inv.payment_method] || inv.payment_method || "—"}</td>
                <td className="py-2 text-right font-mono font-bold text-zinc-100">{formatCurrency(inv.total)}</td>
                <td className="py-2 text-right">
                  <button
                    onClick={() => onPrint(inv)}
                    className="h-7 px-2.5 rounded-md bg-emerald-600 hover:bg-emerald-500 text-white text-[11px] font-semibold inline-flex items-center gap-1"
                    data-testid={`pos-reprint-${inv.invoice_id}`}
                  >
                    <Printer className="w-3 h-3" /> Imprimir
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!loading && invoices.length === 0 && (
          <div className="flex flex-col items-center justify-center py-16 text-zinc-500">
            <FileText className="w-10 h-10 mb-3 opacity-40" />
            <p className="text-sm">Ainda não há faturas hoje</p>
          </div>
        )}
      </div>
    </div>
  );
};
